import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import yardService from "../../services/yardService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const yardFormSchema = [
  {
    name: "yardNo",
    label: "Yard Number",
    type: "text",
    placeholder: "e.g. YARD-001",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 100,
    },
  },
  {
    name: "isActive",
    label: "Active",
    type: "checkbox",
    initialValue: true,
  },
];

function YardCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await yardService.createYard(values);
      alertService.success("Yard created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Yard">
      <CrudForm
        mode="create"
        schema={yardFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default YardCreateModal;
